module.exports = __webpack_public_path__ + "img/setting_28.f7b235f4.svg";